import { startLoading, stopLoading } from 'src/redux/slices/loading'
import { getCourseDetail } from 'src/services/course/detail'

export const fetchCourseDetail = (uuid) => async (dispatch) => {
  dispatch(startLoading())
  await dispatch(getCourseDetail(uuid))
  dispatch(stopLoading())
}
